module.exports = __webpack_public_path__ + "img/2.34cef466.png";